export const DatosPago = {
    banco: ""
}; 